import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const items = [
    {
        title: 'Planning',
        info: 'Lorem ipsum dolor amet, consectetur adipiscing elited uspendisse varius enim',
        icon: 'icon-Mind',
        shape: 'shape-bg-2',
        link: '#'
    },
    {
        title: 'Branding',
        info: 'Lorem ipsum dolor amet, consectetur adipiscing elited uspendisse varius enim',
        icon: 'icon-Pencil',
        shape: 'shape-bg-2',
        link: '#'
    },
    {
        title: 'Marketing',
        info: 'Lorem ipsum dolor amet, consectetur adipiscing elited uspendisse varius enim',
        icon: 'icon-research',
        shape: 'shape-bg-2',
        link: '#'
    },
    {
        title: 'Solution',
        info: 'Lorem ipsum dolor amet, consectetur adipiscing elited uspendisse varius enim',
        icon: 'icon-presentation',
        shape: 'shape-bg-2',
        link: '#'
    },
];

const HowItWorksOne = ( { wrapperClass, itemClass, processes } ) => {
    return (
        <div className={ wrapperClass || 'row g-5 mt--20' }>
            { processes.map( ( data , i ) => (
                <ScrollAnimation 
                    animateIn="fadeIn"
                    animateOut="fadeInOut"
                    className={ itemClass || 'service-card-single col-lg-3 col-md-6 col-12' }
                    animateOnce={ true }
                    key={ i }
                >
                    <div className={`service-card service-card-7 ${data.shape}`}>
                        <div className="inner">
                            <div className="icon">
                                <a href={ data.link }>
                                    <i className={ data.icon }></i>
                                </a>
                            </div>
                            <div className="content">
                                <h6 className="title"><a href={ data.link }>{ data.title }</a></h6>
                                <p className="description">{ data.info }</p>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            ) ) }
        </div>
    )
}

export default HowItWorksOne;